module.exports = __webpack_public_path__ + "static/img/通@2x.71982f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/通@2x.png
// module id = OGzO
// module chunks = 192